import { NgModule } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { StatusMaintenancePipe } from '@fuse/pipes/maintenanceStatus.pipe';
import { EnumPipe } from '@fuse/pipes/status/status.pipe';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { CreateMaintenanceLogsService } from './services/create-maintenance-logs.service';
import { CreateTaskLogsService } from './services/create-task-logs.service';
import { UpdatedByLogService } from './services/updated-by-log.service';
import { StarsModule } from './stars/stars.module';

import { TabLogsComponent } from './tab-logs.component';

@NgModule({
  entryComponents: [
    TabLogsComponent,
  ],
  declarations: [
    TabLogsComponent,
  ],
  imports: [
    TranslateModule,
    FuseSharedModule,
    StarsModule,

    MatIconModule,
    MatFormFieldModule,
    MatSelectModule,
    MatDividerModule
  ],
  providers: [
    EnumPipe,
    CreateTaskLogsService,
    CreateMaintenanceLogsService,
    StatusMaintenancePipe,
    UpdatedByLogService,
  ],
  exports: [
    TabLogsComponent
  ]
})
export class TabLogsModule { }
